export const MfaType = {
  AUTHENTICATOR: {
    key: "AUTHENTICATOR",
    setUpModalKey: "authenticatorSetUp",
  },
  SMS: {
    key: "SMS",
    setUpModalKey: "smsMfaSetUp",
  },
};

export type MfaTypeKeys = keyof typeof MfaType;
